module.exports = __webpack_public_path__ + "media/img/corporate/pac2-c68acfa20e4b5cf3c99a29de0342f570.svg";